import React, { useState } from "react";
import AddButton from "../../../../partials/Buttons/AddButton";
import PrimaryButton from "../../../../partials/Buttons/PrimaryButton";
import CancelButton from "../../../../partials/Buttons/CancelButton";
import renderHTML from "react-render-html";
import { UPDATE_REJECTION } from "../../../../queries/patient.query";
import { useMutation } from "react-apollo";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";
import LoadingSpinner from "../../../../partials/loading";
import Editor from "../../../../partials/Editor";
import { sendNotification } from "../../../../sockette";
import { EVENT_TARGET, ACTION_TYPE } from "../../../../event/model";
import { EventEmitter } from "../../../../event/EventEmitter";

const PatientRejection = ({ id, rejection, isAdmin }) => {
    const [_rejection, setRejection] = useState(rejection);
    const [update, setUpdate] = useState(false);

    const [updateRejectionFunc, { loading }] = useMutation(UPDATE_REJECTION, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.UpdateRejection) {
                const { message, doc } = d.UpdateRejection;
                toast.success(message);
                sendNotification(doc, ACTION_TYPE.UPDATE, EVENT_TARGET.PATIENT);
                setUpdate(false);
            }
        },
    });

    EventEmitter.subscribe(EVENT_TARGET.Rejection, (event) => setRejection(event));

    return (
        <div className="card">
            <div className="card-head">
                <header>Patient Rejection</header>
            </div>
            <div className="card-body min-card">
                <LoadingSpinner loading={loading} bar={true} />
                <div>
                    {!update && (
                        <div className="fade-in">
                            {renderHTML(_rejection || "<p>No rejection added!</p>")}
                            <br />
                        </div>
                    )}

                    {update && (
                        <div className="fade-in">
                            <Editor height={200} content={_rejection} onChange={(data) => setRejection(data)} />

                            <div className="text-right mt-5 mb-3">
                                <PrimaryButton
                                    title="Update"
                                    onClick={async () => {
                                        if (id && _rejection) await updateRejectionFunc({ variables: { id, rejection: _rejection } });
                                        else toast.warn("Rejection can not be empty!");
                                    }}
                                />
                                <CancelButton
                                    onClick={() => {
                                        setUpdate(false);
                                        setRejection(_rejection);
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {isAdmin && !update && (
                <div className="card-footer text-right fade-in">
                    <AddButton onClick={() => setUpdate(true)} />
                </div>
            )}
        </div>
    );
};

export default PatientRejection;
